// ©2024 Austin App House. All rights reserved.
import React, {useEffect, useState} from 'react';
import {sortableContainer, sortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import Notification from '../../components/notification';
import DashboardIcon from '../dashboard/icons/DashboardIcon';

const WorkOrderTasks = ({tasks, handler}) => {
    const [onSiteRequirements, setOnSiteRequirements] = useState(tasks);
    const [isModalOpen, changeModalState] = useState(false);
    const [selectedCategory, changeCategory] = useState('preArrivalRequirements');
    const [newTask, addDescriptionForNewTask] = useState('');
    const SortableGifsContainer = sortableContainer(({children}) => (
        <div style={{display: 'flex', flexDirection: 'column'}} className="gifs">{children}</div>
    ));
    const TaskElement = ({ name, index, collection }) => (
        <span style={{ marginBottom: 10, width: 'fit-content', display: 'inline-flex', alignItems: 'center' }} className="chip">
      {name}

            <button
                type="button"
                className="row-action-btn row-action-btn--danger row-action-btn--compact"
                aria-label="remove task"
                onClick={(event) => {
                    event.preventDefault();
                    setOnSiteRequirements(prev => ({
                        ...prev,
                        [collection]: prev[collection]
                            .filter(el => el.index !== index)
                            .map((el, newIdx) => ({ ...el, index: newIdx }))
                    }));
                    Notification('success', { message: 'Task was deleted' });
                }}
            >
                <DashboardIcon name="close" size={12} strokeWidth="2" />
            </button>
    </span>
    );
    const addNewTask = () => {
        if (!newTask || !selectedCategory) {
            Notification('warning', {message: 'Please enter a requirement.'});
        } else {
            Notification('success', {message: 'Task was added'});
            setOnSiteRequirements({
                ...onSiteRequirements,
                [selectedCategory]: [
                    ...onSiteRequirements[selectedCategory],
                    {name: newTask, checked: false, index: onSiteRequirements[selectedCategory].length},
                ],
            });
            addDescriptionForNewTask('');
            changeModalState(false);
        }
    };
    const SortableGif = sortableElement(({element: {name, index, collection}}) => (
        <TaskElement name={name} index={index} collection={collection}/>
    ));
    const onSortEnd = ({oldIndex, newIndex, collection}) => {
        setOnSiteRequirements({
            ...onSiteRequirements,
            [collection]: arrayMove(onSiteRequirements[collection], oldIndex, newIndex)
                .reduce((acc, el, index) => {
                    acc.push({...el, index});
                    return acc;
                }, []),
        });
    };
    useEffect(() => {
        setOnSiteRequirements(tasks);
    }, [tasks]);
    useEffect(() => {
        handler(onSiteRequirements);
    }, [onSiteRequirements]);

    const closeRequirementModal = () => {
        addDescriptionForNewTask('');
        changeModalState(false);
    };

    return (
        <>
            <div className="add_btns">
                <button type="button" aria-label="add required steps" className="standard_btn icon_plus" onClick={() => changeModalState(true)}>
                    Add Required Steps
                </button>
            </div>
            <div className="fields_group">
                <div className="block_title">Required Steps</div>
                <table className="custom_table">
                    <thead>
                    <tr>
                        <th className="arrival">Pre Arrival Requirements</th>
                        <th className="site">On Site Requirements</th>
                        <th className="completion">Completion Requirements</th>
                    </tr>
                    </thead>
                    {onSiteRequirements ? (

                        <tbody>
                        <tr>
                            <td>
                                <SortableGifsContainer onSortEnd={onSortEnd} distance={1}>
                                    {onSiteRequirements.preArrivalRequirements.map((el, i) => (
                                        <SortableGif
                                            index={i}
                                            /* eslint-disable-next-line react/no-array-index-key */
                                            key={`pre-${i}`}
                                            element={{...el, collection: 'preArrivalRequirements'}}
                                            collection="preArrivalRequirements"
                                        />
                                    ))}
                                </SortableGifsContainer>
                                {/* {onSiteRequirements.preArrivalRequirements.map((el, i) => (
              <TaskElement key={`pre-${i}`} name={el.name} index={i} collection="preArrivalRequirements" />
            ))} */}
                            </td>
                            <td>
                                <SortableGifsContainer onSortEnd={onSortEnd} distance={1}>
                                    {onSiteRequirements.onSiteRequirements.map((el, i) => (
                                        <SortableGif
                                            index={i}
                                            /* eslint-disable-next-line react/no-array-index-key */
                                            key={`site-${i}`}
                                            element={{...el, collection: 'onSiteRequirements'}}
                                            collection="onSiteRequirements"
                                        />
                                    ))}
                                </SortableGifsContainer>
                            </td>
                            <td>
                                <SortableGifsContainer onSortEnd={onSortEnd} distance={1}>
                                    {onSiteRequirements.completionRequirements.map((el, i) => (
                                        <SortableGif
                                            index={i}
                                            /* eslint-disable-next-line react/no-array-index-key */
                                            key={`comp-${i}`}
                                            element={{...el, collection: 'completionRequirements'}}
                                            collection="completionRequirements"
                                        />
                                    ))}
                                </SortableGifsContainer>
                            </td>
                        </tr>
                        </tbody>
                    ) : (
                        <tbody>
                        <tr>
                            <td colSpan="3">No requirements found</td>
                        </tr>
                        </tbody>
                    )}
                </table>
            </div>
            {isModalOpen && (
                <div
                    className="dashboard-modal dashboard-modal--open"
                    role="presentation"
                    onClick={closeRequirementModal}
                >
                    <div
                        className="dashboard-modal-panel"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="add-requirement-title"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="dashboard-modal-header">
                            <div className="dashboard-modal-title" id="add-requirement-title">Add Requirement</div>
                            <button
                                className="dashboard-modal-close"
                                aria-label="close"
                                onClick={closeRequirementModal}
                            />
                        </div>

                        <div className="dashboard-modal-body">
                            <div className="field_row">
                                <div className="field_name">
                                    <label htmlFor="requirement_type">Select Requirement Type</label>
                                </div>
                                <div className="field_block">
                                    <select
                                        id="requirement_type"
                                        className="browser-default custom-select selectac"
                                        onChange={(e) => changeCategory(e.target.value)}
                                        value={selectedCategory}
                                    >
                                        <option value="preArrivalRequirements">Pre Arrival Requirements</option>
                                        <option value="onSiteRequirements">On Site Requirements</option>
                                        <option value="completionRequirements">Completion Requirements</option>
                                    </select>
                                </div>
                            </div>

                            <div className="field_row">
                                <div className="field_name">
                                    <label htmlFor="requirement_name">Requirement</label>
                                </div>
                                <div className="field_block">
                                    <input
                                        type="text"
                                        id="requirement_name"
                                        className="form-control"
                                        placeholder="Type requirement description"
                                        value={newTask}
                                        onChange={(e) => addDescriptionForNewTask(e.target.value)}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="dashboard-modal-footer">
                            <button
                                className="dashboard-btn dashboard-btn--secondary"
                                aria-label="cancel"
                                type="button"
                                onClick={closeRequirementModal}
                            >Cancel
                            </button>
                            <button
                                className="dashboard-btn dashboard-btn--primary"
                                aria-label="save"
                                type="button"
                                onClick={addNewTask}
                            >Add
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default WorkOrderTasks;
